import styled from '@emotion/styled';
import {
  Column,
  Row,
  device,
  Reveal,
  zebraTable,
  standardTable,
  smallTable,
  shouldForwardProp,
} from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  background?: string;
  layout?: string;
  theme?: 'primary' | 'secondary' | 'ternary';
  children: React.ReactNode;
  copy?: React.ReactNode | null;
  noHeadingUnderline?: boolean;
}

interface TableProps {
  background?: string;
  colorTheme?: 'primary' | 'secondary' | 'ternary';
  noHeadingUnderline?: boolean;
}

const ZebraHost = styled.div``;

const ZebraTableWrapper = styled(Reveal, {
  shouldForwardProp: shouldForwardProp('div'),
})<TableProps>`
  ${(props) => zebraTable(props.background, props.colorTheme)}
`;

const StandardHost = styled.div``;

const StandardTableWrapper = styled(Reveal, {
  shouldForwardProp: shouldForwardProp('div'),
})<TableProps>`
  ${(props) => standardTable(props.background, props.noHeadingUnderline)}

  @media ${device.tablet} {
    padding: 90px 0;
  }
`;

const SmallTableWrapper = styled(Reveal, {
  shouldForwardProp: shouldForwardProp('div'),
})<TableProps>`
  ${(props) => smallTable(props.background)}
`;

const Copy = styled.div`
  margin-bottom: 60px;

  ${device.tablet} {
    max-width: 70%;
  }
`;

export const PrismicTable = ({
  background,
  layout,
  theme = 'primary',
  children,
  copy,
  noHeadingUnderline = true,
}: IProps) => {
  if (layout === 'Zebra') {
    return (
      <ZebraHost>
        {copy && <Copy>{copy}</Copy>}
        <ZebraTableWrapper background={background} colorTheme={theme}>
          {children}
        </ZebraTableWrapper>
      </ZebraHost>
    );
  }
  if (layout === 'Small') {
    return (
      <StandardHost>
        <SmallTableWrapper background={background}>
          {children}
        </SmallTableWrapper>
      </StandardHost>
    );
  } else {
    return (
      <StandardHost>
        {!!copy && (
          <Row>
            <Column
              lg={{ width: 7 / 12, offset: 1 / 12 }}
              md={{ width: 8 / 12 }}
            >
              <Copy>{copy}</Copy>
            </Column>
          </Row>
        )}
        <Row>
          <Column lg={{ width: 10 / 12, offset: 1 / 12 }}>
            <StandardTableWrapper
              background={background}
              noHeadingUnderline={noHeadingUnderline}
            >
              {children}
            </StandardTableWrapper>
          </Column>
        </Row>
      </StandardHost>
    );
  }
};
